module.exports = __webpack_public_path__ + "static/media/sunny.5bd85ea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sunny.svg
// module id = 1104
// module chunks = 0